module.exports = __webpack_public_path__ + "img/bairro-penha.4dc5112c.png";